/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';

import { OutlinedInput } from '@material-ui/core';
import SearchIcon from '@mui/icons-material/Search';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';

import useStyles, { SearchButton } from './styles';
import { Box } from '@mui/system';

export function InputSearch({ onClick, buttonColor, fontFamily, isLoading, iconColor }) {
  const classes = useStyles({ fontFamily });
  const [value, setValue] = React.useState('');

  const handleClick = () => {
    onClick(value);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleClick();
    }
  };
  return (
    <div className={classes.formControl} onKeyPress={handleKeyPress}>
      <OutlinedInput
        className={classes.outilneInput}
        fullWidth
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Digite seu cep"
      />
      <SearchButton
        type="button"
        className={classes.buttonSearch}
        onClick={handleClick}
        buttonColor={buttonColor}
        iconColor={iconColor}
      >
        {isLoading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '100%',
            }}
          >
            <CircularProgress
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: iconColor,
              }}
            />
          </Box>
        ) : (
          <SearchIcon />
        )}
      </SearchButton>
    </div>
  );
}

InputSearch.propTypes = {
  onClick: PropTypes.func.isRequired,
};
